import { useEffect, useState } from "react";

/**
 * Below this window width the Studio gives its canvas the room: the screens collapse to a strip of thumbnails and the
 * full list and the inspector open as drawers over the canvas, on demand. At 1024x768 that is the difference between
 * a 1280px-wide page drawn at ~35% and at ~72%. The class it sets (`.studio-wrap.compact`) is the only switch the
 * stylesheet uses, so the layout and the code that depends on it (the canvas fit, the drawers) can't disagree.
 */
export const COMPACT_QUERY = "(max-width: 1279.98px)";

export function useCompact(): boolean {
  const [compact, setCompact] = useState(() => typeof matchMedia === "function" && matchMedia(COMPACT_QUERY).matches);
  useEffect(() => {
    const mq = matchMedia(COMPACT_QUERY);
    const on = () => setCompact(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return compact;
}

/** Which drawer is open in the compact Studio: the full screen list (left) or the inspector (right). One at a time. */
export type Drawer = "steps" | "inspector" | null;
export const DRAWER_ID: Record<Exclude<Drawer, null>, string> = { steps: "studio-steps", inspector: "studio-inspector" };
